import common from '../common';

export default class Disaster {
	constructor(world) {
		this._world = world;

		this._isRunning = false;
		this._canStart = false;
		this._cb = null;
		this.signals = {};

		this._totalDeaths = 0;
		this._totalInjury = 0;
		this._totalSurvive = 0;
		this._totalCost = 0;
		this._totalDestroyed = 0;
		this._totalSheltered = 0;
		this._hospitalDestroyed = false;
		this._schoolDestroyed = false;

		this._tweens = new TWEEN.Group();

		this.signals.disasterStart = new P3.utils.MiniSignal();
		this.signals.disasterEnd = new P3.utils.MiniSignal();
		this._ambientSound = null;
	}

	/**
	 * Called when the disaster is started
	 */
	start(cb) {
		this._cb = cb;
		if (!this._isRunning && this._canStart) {
			common.scenario.finished = true;
			this._isRunning = true;
			this._canStart = false;
			this.signals.disasterStart.dispatch();

			return true;
		}

		return false;
	}

	stopSounds() {
		if (this._ambientSound) {
			this._ambientSound.stop();
			P3.audio.cleanupAudio(this._ambientSound);
		}
		this._ambientSound = null;
	}

	destroy() {
		this.stopSounds();

		P3.utils.destroyAllSignals(this.signals);
		this._tweens.removeAll();
	}

	stop() {
		this._isRunning = false;
		this._canStart = false;
	}

	/**
	 * Called when the disaster ends
	 */
	end() {
		// override
	}

	resize() {
		// override
	}

	update() {
		this._tweens.update();
	}

	damageStructure(tile) {
		// override
	}

	destroyStructure(tile) {
		const structure = this._world.getStructure(tile.structure);

		if (typeof structure.debris === 'boolean' ? structure.debris : true) {
			const t = P3.utils.selectRandom(this._world.getStructureByGroup(380));

			tile.structure = t.id;
		} else {
			tile.structure = 0;
		}
	}

	get world() {
		return this._world;
	}

	get isRunning() {
		return this._isRunning;
	}

	get canStart() {
		return this._canStart;
	}

	set canStart(value) {
		this._canStart = value;
	}

	get totalDeaths() {
		return this._totalDeaths;
	}

	get totalCost() {
		return this._totalCost;
	}

	get totalInjury() {
		return this._totalInjury;
	}

	get totalSurvive() {
		return this._totalSurvive;
	}

	get totalDestroyed() {
		return this._totalDestroyed;
	}

	get totalSheltered() {
		return this._totalSheltered;
	}

	get hospitalDestroyed() {
		return this._hospitalDestroyed;
	}

	get schoolDestroyed() {
		return this._schoolDestroyed;
	}

	get ambientsound() {
		return this._ambientSound;
	}
}
